/**
 * Replay Sharing Service
 * Handles creating and fetching shared game replays
 */

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Share a game and get a shareable link
 */
export async function shareReplay(gameData) {
  try {
    const response = await fetch(`${API_URL}/api/replays/share`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        game_name: gameData.name || `Game ${new Date().toLocaleDateString()}`,
        fen: gameData.fen,
        pgn: gameData.pgn || '',
        history: gameData.history || [],
        player_color: gameData.playerColor || 'white',
        result: gameData.result || null,
        difficulty: gameData.difficulty || 'medium',
        move_analysis: gameData.moveAnalysis || null
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to share replay');
    }

    return await response.json();
  } catch (error) {
    console.error('Share replay error:', error);
    throw error;
  }
}

/**
 * Get a shared replay by ID (public - no auth required)
 */
export async function getSharedReplay(replayId) {
  try {
    const response = await fetch(`${API_URL}/api/replays/${replayId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Replay not found');
      }
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch replay');
    }

    return await response.json();
  } catch (error) {
    console.error('Get replay error:', error);
    throw error;
  }
}

/**
 * Get replays shared by current user
 */
export async function getMySharedReplays(limit = 20) {
  try {
    const response = await fetch(`${API_URL}/api/replays?limit=${limit}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch replays');
    }

    return await response.json();
  } catch (error) {
    console.error('Get my replays error:', error);
    throw error;
  }
}

/**
 * Delete a shared replay
 */
export async function deleteSharedReplay(replayId) {
  try {
    const response = await fetch(`${API_URL}/api/replays/${replayId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to delete replay');
    }

    return await response.json();
  } catch (error) {
    console.error('Delete replay error:', error);
    throw error;
  }
}
